<template>
	<div>
		<details-page-gen :options="options" />
	</div>
</template>

<script>
import DetailsPageGen from './DetailsPageGen.vue'

const config = {
	options: {
		resource: 'locales'
	}
}

export default {
	name: 'LocaleDetails',
	components: { DetailsPageGen },
	data: () => config
}
</script>
